module.exports = __webpack_public_path__ + "img/cart-active.31775605.svg";